<template>
  <div class="i18n-flags">
    <img
      :alt="language.label"
      style="cursor: pointer"
      :key="language.id"
      :src="language.flag"
      :title="language.label"
      @click="doChangeLanguage(language.id)"
      v-for="language in languages"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// import { I18nUtil } from '@/shared/i18n/i18n-util';
import i18n from '@/vueI18n';
import { getLanguages } from '@/i18n';
// import { getLanguages, setLanguageCode } from '@/i18n';
// import Quasar from 'quasar'

export default {
  name: 'app-i18n-flags',

  computed: {
    languages() {
      return getLanguages();
    },
  },

  methods: {
    ...mapActions({
      changeCurrentLanguageCode:
        'saryahLanding/landing/changeCurrentLanguageCode',
    }),
    // doChangeLanguage(language) {
    //   if(language != localStorage.getItem('language')) {
    //     I18nUtil.doChangeLanguage(language);
    //   }
    // },

    // doChangeLanguage(language) {
    //   i18n.locale = language;
    //   localStorage.setItem('language', language);

    //   const { lang } = this.$route.params;
    //   let route = '';
    //   if (lang && (lang === 'ar' || lang === 'en')) {
    //     route = `/${language}${this.$route.fullPath.substring(3)}`;
    //   } else {
    //     route = `/${language}${this.$route.fullPath}`;
    //   }
    //   if (language === 'ar') {
    //     // document.getElementsByTagName("html")[0].setAttribute("dir","rtl")
    //     // this.$q.lang.rtl = true
    //     // this.ar = true
    //     import(`quasar/lang/ar`).then((lang) => {
    //       // eslint-disable-next-line
    //       Quasar.lang.set(lang.default);
    //     });
    //   } else {
    //     // document.getElementsByTagName("html")[0].setAttribute("dir","ltr")
    //     // this.$q.lang.rtl = false
    //     // this.ar = false
    //     import(`quasar/lang/en-us`).then((lang) => {
    //       // eslint-disable-next-line
    //       Quasar.lang.set(lang.default);
    //     });
    //   }
    //   this.$router.push(route);
    //   // I18nUtil.doChangeLanguage(language);
    // },

    // ==========================================
    //#region [old change language]
    // doChangeLanguage(language) {
    //   i18n.locale = language;
    //   localStorage.setItem('language', language);
    //   setLanguageCode(language)
    //   this.changeCurrentLanguageCode(language)

    //   const { lang } = this.$route.params;
    //   let route = '';
    //   if (lang && (lang === 'ar' || lang === 'en')) {
    //     route = `/${language}${this.$route.fullPath.substring(3)}`;
    //   } else {
    //     route = `/${language}${this.$route.fullPath}`;
    //   }

    //   if (language === 'ar') {
    //     import(`quasar/lang/ar`).then((lang) => {
    //       console.log(lang);
    //       // eslint-disable-next-line
    //       Quasar.lang.set(lang.default);
    //     });
    //   } else {
    //     import(`quasar/lang/en-us`).then((lang) => {
    //       console.log(lang);
    //       // eslint-disable-next-line
    //       Quasar.lang.set(lang.default);
    //     });
    //   }
    //   this.$router.push(route);
    //   // I18nUtil.doChangeLanguage(language);
    // },
    //#endregion
    //  ==============================================
    doChangeLanguage(language) {
      i18n.locale = language;
      localStorage.setItem('language', language);
      const { lang } = this.$route.params;
      let route = '';
      if (lang && (lang === 'ar' || lang === 'en')) {
        route = `/${language}${this.$route.fullPath.substring(
          3,
        )}`;
      } else {
        route = `/${language}${this.$route.fullPath}`;
      }
      if (language === 'ar') {
        document
          .getElementsByTagName('html')[0]
          .setAttribute('dir', 'rtl');
        document
          .getElementsByTagName('html')[0]
          .setAttribute('lang', 'ar');
        document
          .getElementById('app')
          .setAttribute('dir', 'rtl');
        this.$q.lang.rtl = true;
        this.lang = 'ar';
      } else {
        document
          .getElementsByTagName('html')[0]
          .setAttribute('dir', 'ltr');
        document
          .getElementsByTagName('html')[0]
          .setAttribute('lang', 'en-us');
        document
          .getElementById('app')
          .setAttribute('dir', 'ltr');
        this.$q.lang.rtl = false;
        this.lang = 'en';
      }
      this.$router.push(route);
      // I18nUtil.doChangeLanguage(language);
    },
  },
};
</script>

<style>
.i18n-flags {
  display: flex;
  align-items: center;
  justify-content: center;
}

.i18n-flags img {
  margin-right: 8px;
  cursor: pointer;
}
</style>